import * as moment from 'moment';
import { EventModel } from 'src/app/pagesAdmin/events/event.model';
//import { v4 as uuidv4 } from 'uuid';

declare let argon2: any;

export const toFixedNoRounding = (value: any, decimals: any) => {
  const reg = new RegExp('^-?\\d+(?:\\.\\d{0,' + decimals + '})?', 'g');
  const a = value.toString().match(reg)?.[0];
  if (!a) {
    return '0.' + '0'.repeat(decimals);
  }
  const dot = a.indexOf('.');
  if (dot === -1) {
    // integer, insert decimal dot and pad up zeros
    return a + '.' + '0'.repeat(decimals);
  }
  const b = decimals - (a.length - dot) + 1;
  return b > 0 ? a + '0'.repeat(b) : a;
};

export const formatDate = (date: any, separator = '-') => {
  if (date instanceof Date) {
    return moment(date).format('YYYY-MM-DD');
  }

  if (date.indexOf('T') !== -1) {
    date = date.split('T')[0];
  }

  if (date.indexOf(separator) === -1) {
    return date;
  }

  const parts: any = date.split(separator);
  return parts[2] + '-' + parts[1] + '-' + parts[0];
};

export const formatDateReverse = (date: any, separator = '-') => {
  if (date instanceof Date) {
    return moment(date).format('DD-MM-YYYY');
  }

  if (date.indexOf('T') !== -1) {
    date = date.split('T')[0];
  }

  const parts: any = date.split(separator);
  return parts[0] + '-' + parts[1] + '-' + parts[2];
};

export const toPositiveNumber = (val: any) => {
  return Math.abs(val);
};

// export const generatePassHash = (plain: string): Promise<any> => {
// 	return argon2
// 		.hash({
// 			pass: plain,
// 			salt: btoa(JSON.stringify({p: plain})),
// 			//salt: uuidv4(),
// 			type: 2, // Argon2id
// 		})
// 		.then((r) => r.encoded);
// };

export const handleNgbDate = (_ngbDate: any) => {
  if (!_ngbDate) {
    return null;
  }

  return {
    day: Number(moment(_ngbDate).format('DD')),
    month: Number(moment(_ngbDate).format('MM')),
    year: Number(moment(_ngbDate).format('YYYY')),
  };
};

export const handleReverseNgbDate = (_ngbDate: any) => {
  return (
    _ngbDate['year'].toString().padStart(2, '0') +
    '-' +
    _ngbDate['month'].toString().padStart(2, '0') +
    '-' +
    _ngbDate['day'].toString().padStart(2, '0')
  );
};

export const normalizeAmount = (val: any) => {
  return Number(toFixedNoRounding((val * 100).toFixed(2), 2));
};

export const normalizeAmountDot = (val: any, multiply = true) => {
  if (val === null || val === undefined || val === '') {
    return 0;
  }

  if (multiply) {
    val = normalizeAmount(val);
  }

  let stringValue = val.toString();

  // Remover formatação de moeda brasileira se existir
  // stringValue = stringValue
  //   .replace(/[R$\s]/g, '') // Remove R$ e espaços
  //   .replace(/\./g, '') // Remove pontos de milhares
  //   .replace(',', '.'); // Converte vírgula decimal para ponto

  const numericValue = parseFloat(stringValue) || 0;

  // Converter para centavos (multiplicar por 100)
  return Math.round(numericValue);
};

export const moneyFormatting = (val: any) => {
  return (val / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    currencyDisplay: 'symbol',
  });
};

export const mobilecheck = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || (window as any).opera);
  return check;
};

export function randomNumber(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const isIOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

const resolveEventCatalog = (
  fallback: any[],
  configured: any[] = [],
  hasAdminLabel = false,
  admin = false,
): any[] => {
  return fallback.map((item: any) => {
    const resolved = configured?.find(
      (candidate: any) => candidate.code === item.CODE,
    );

    if (!resolved) {
      return { ...item };
    }

    return {
      ...item,
      DESC: admin && hasAdminLabel ? resolved.adminLabel : resolved.label,
      ...(hasAdminLabel
        ? { DESC_ADMIN: resolved.adminLabel || resolved.label }
        : {}),
    };
  });
};

export const handleSteps = (
  type: string,
  isUser = false,
  repairOnlyThirdParty = false,
  isImplement = false,
  configuration?: any,
) => {
  let eventSteps = resolveEventCatalog(
    Object.values(EventModel.STEPS),
    configuration?.eventTerminology?.steps,
    true,
    !isUser,
  );

  if (
    (type === EventModel.TYPES.CRASH.CODE ||
      type === EventModel.TYPES.ROLLOVER.CODE) &&
    repairOnlyThirdParty
  ) {
    const allowedCodes = [
      EventModel.STEPS.COMMUNICATION.CODE,
      EventModel.STEPS.OPENING.CODE,
      EventModel.STEPS.INSPECTION.CODE,
      EventModel.STEPS.INQUIRY.CODE,
      EventModel.STEPS.LIBERATION.CODE,
    ];
    eventSteps = eventSteps.filter((step) => allowedCodes.includes(step.CODE));
  }

  if (
    ((type === EventModel.TYPES.CRASH.CODE ||
      type === EventModel.TYPES.ROLLOVER.CODE) &&
      !repairOnlyThirdParty) ||
    type === EventModel.TYPES.THIRD_PARTY_MONITORING.CODE ||
    type === EventModel.TYPES.NATURAL_PHENOMENA.CODE ||
    type === EventModel.TYPES.FIRE.CODE
  ) {
    eventSteps = eventSteps.filter(
      (x) =>
        x.CODE !== EventModel.STEPS.PAYMENT_SCHEDULE.CODE &&
        x.CODE !== EventModel.STEPS.COMPENSATION_TERM.CODE &&
        x.CODE !== EventModel.STEPS.COMPENSATION_DOCUMENTATION.CODE &&
        x.CODE !== EventModel.STEPS.PAYMENT.CODE,
    );
  }

  if (type === EventModel.TYPES.ROBBERY_AND_THEFT.CODE) {
    eventSteps = eventSteps.filter(
      (x) =>
        x.CODE !== EventModel.STEPS.INSPECTION.CODE &&
        x.CODE !== EventModel.STEPS.INSPECTION_DELIVERY.CODE &&
        x.CODE !== EventModel.STEPS.CAR_REPAIR.CODE &&
        x.CODE !== EventModel.STEPS.CAR_PARTS.CODE &&
        x.CODE !== EventModel.STEPS.SERVICE.CODE &&
        x.CODE !== EventModel.STEPS.DELIVERY.CODE,
    );

    if (isUser) {
      eventSteps = eventSteps.filter(
        (x) => x.CODE !== EventModel.STEPS.PAYMENT_SCHEDULE.CODE,
      );
    }

    if (configuration?.removeStepCompensationDocumentation) {
      eventSteps = eventSteps.filter(
        (x) => x.CODE !== EventModel.STEPS.COMPENSATION_DOCUMENTATION.CODE,
      );
    }
  }

  if (type === EventModel.TYPES.PROPERTY_DAMAGE.CODE) {
    eventSteps = eventSteps.filter(
      (x) =>
        x.CODE !== EventModel.STEPS.INSPECTION.CODE &&
        x.CODE !== EventModel.STEPS.INSPECTION_DELIVERY.CODE &&
        x.CODE !== EventModel.STEPS.CAR_REPAIR.CODE &&
        x.CODE !== EventModel.STEPS.CAR_PARTS.CODE &&
        x.CODE !== EventModel.STEPS.SERVICE.CODE &&
        x.CODE !== EventModel.STEPS.DELIVERY.CODE &&
        x.CODE !== EventModel.STEPS.LIBERATION.CODE,
    );

    if (isUser) {
      eventSteps = eventSteps.filter(
        (x) => x.CODE !== EventModel.STEPS.PAYMENT_SCHEDULE.CODE,
      );
    }
  }

  if (type === EventModel.TYPES.GLASS_AND_ACCESSORIES.CODE) {
    eventSteps = eventSteps.filter(
      (x) =>
        x.CODE !== EventModel.STEPS.PAYMENT_SCHEDULE.CODE &&
        x.CODE !== EventModel.STEPS.COMPENSATION_TERM.CODE &&
        x.CODE !== EventModel.STEPS.COMPENSATION_DOCUMENTATION.CODE &&
        x.CODE !== EventModel.STEPS.PAYMENT.CODE &&
        x.CODE !== EventModel.STEPS.INSPECTION.CODE &&
        x.CODE !== EventModel.STEPS.INSPECTION_DELIVERY.CODE,
    );
  }

  if (type === EventModel.TYPES.DRIVER_MONITORING.CODE) {
    eventSteps = eventSteps.filter(
      (x) => x.CODE === EventModel.STEPS.OPENING.CODE,
    );
  }

  if (isImplement) {
    eventSteps = eventSteps.filter(
      (x) => x.CODE !== EventModel.STEPS.COMMUNICATION.CODE,
    );
  }

  const ownerRef = getOwnerRef();

  // quando o host for liga.upwebsolucoes.com inverter EventModel.STEPS.INSPECTION EventModel.STEPS.INQUIRY se existirem no array

  if (ownerRef === 'liga') {
    const inspectionIndex = eventSteps.findIndex(
      (x) => x.CODE === EventModel.STEPS.INSPECTION.CODE,
    );
    const inquiryIndex = eventSteps.findIndex(
      (x) => x.CODE === EventModel.STEPS.INQUIRY.CODE,
    );

    if (inspectionIndex !== -1 && inquiryIndex !== -1) {
      // inverter
      const temp = eventSteps[inspectionIndex];
      eventSteps[inspectionIndex] = eventSteps[inquiryIndex];
      eventSteps[inquiryIndex] = temp;
    }
  }

  return eventSteps;
};

// export const handleStepsDone = (type: string, currentStep: string) => {
//   const completedSteps: string[] = [];

//   const stepsByType = handleSteps(type);

//   for (const step of stepsByType) {
//     if (step.CODE === currentStep) {
//       break;
//     }

//     completedSteps.push(step.CODE);
//   }

//   return completedSteps;
// }

export const handleTriggerSteps = (
  type: string,
  parentEventType?: string,
  eventVehicleDriver?: string,
  configuration?: any,
  isImplement = false,
) => {
  if (!type) {
    throw new Error('Type is null or empty');
  }

  let triggerSteps: any[] = [];

  const configuredTriggerSteps = resolveEventCatalog(
    Object.values(EventModel.TRIGGER_STEPS),
    configuration?.eventTerminology?.triggerSteps,
  );

  triggerSteps = configuredTriggerSteps.filter(
    (x) =>
      x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
      x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
  );

  if (isImplement) {
    return triggerSteps.filter((step) =>
      [
        EventModel.TRIGGER_STEPS.TRIGGER_TERM.CODE,
        EventModel.TRIGGER_STEPS.IN_ANALYSIS.CODE,
      ].includes(step.CODE),
    );
  }

  if (type === EventModel.TYPES.DRIVER_MONITORING.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (s) =>
        s.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        s.CODE !== EventModel.TRIGGER_STEPS.DRIVER_VEHICLE.CODE &&
        s.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        s.CODE !== EventModel.TRIGGER_STEPS.CONFIRMATION.CODE &&
        s.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (type === EventModel.TYPES.THIRD_PARTY_MONITORING.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.CONFIRMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (parentEventType === EventModel.TYPES.THIRD_PARTY_MONITORING.CODE) {
    triggerSteps = triggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.CONFIRMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (type === EventModel.TYPES.PROPERTY_DAMAGE.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.CONFIRMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IDENTITY_VERIFICATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.DRIVER_VEHICLE.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.INCIDENT_LOCATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.WITNESSES.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.CLARIFICATION_FACTS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.OCCURRENCE_REPORT.CODE,
    );
  }

  if (parentEventType === EventModel.TYPES.PROPERTY_DAMAGE.CODE) {
    triggerSteps = triggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.CONFIRMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IDENTITY_VERIFICATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.DRIVER_VEHICLE.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.INCIDENT_LOCATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.WITNESSES.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.CLARIFICATION_FACTS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.IMPORTANT_INFORMATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.OCCURRENCE_REPORT.CODE,
    );
  }

  if (type === EventModel.TYPES.ROBBERY_AND_THEFT.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (parentEventType === EventModel.TYPES.ROBBERY_AND_THEFT.CODE) {
    triggerSteps = triggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (type === EventModel.TYPES.GLASS_AND_ACCESSORIES.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.CLARIFICATION_FACTS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );

    if (configuration?.removeStepBOInGlassAndAccessories) {
      triggerSteps = triggerSteps.filter(
        (x) => x.CODE !== EventModel.TRIGGER_STEPS.OCCURRENCE_REPORT.CODE,
      );
    }
  }

  if (parentEventType === EventModel.TYPES.GLASS_AND_ACCESSORIES.CODE) {
    triggerSteps = triggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.CLARIFICATION_FACTS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );

    if (configuration?.removeStepBOInGlassAndAccessories) {
      triggerSteps = triggerSteps.filter(
        (x) => x.CODE !== EventModel.TRIGGER_STEPS.OCCURRENCE_REPORT.CODE,
      );
    }
  }

  if (type === EventModel.TYPES.NATURAL_PHENOMENA.CODE) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (parentEventType === EventModel.TYPES.NATURAL_PHENOMENA.CODE) {
    triggerSteps = triggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  if (type === EventModel.TYPES.FIRE.CODE) {
    // nada a fazer
  }

  if (
    type !== EventModel.TYPES.DRIVER_MONITORING.CODE &&
    type !== EventModel.TYPES.THIRD_PARTY_MONITORING.CODE &&
    eventVehicleDriver === EventModel.VEHICLE_DRIVER.OTHER.CODE &&
    configuration?.vehicleDriverOtherEventEnabled
  ) {
    triggerSteps = configuredTriggerSteps.filter(
      (x) =>
        x.CODE !== EventModel.TRIGGER_STEPS.THIRD_PARTY_DATA.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.ACCIDENT_INVOLVED.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.INCIDENT_LOCATION.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.WITNESSES.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.CLARIFICATION_FACTS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.DESCRIPTION_INCIDENT.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.PHOTOS.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.OCCURRENCE_REPORT.CODE &&
        x.CODE !== EventModel.TRIGGER_STEPS.REPAIR_BUDGET.CODE,
    );
  }

  return triggerSteps;
};

export const convertToTitleCase = (str: string) => {
  if (!str) {
    return str;
  }

  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const fixDate = (date: any) => {
  date = date.toString();
  const parts = date.split('T');
  return parts.length > 2 ? parts[0].toString() + 'T' + parts[1] : date;
};

export const getOwnerRef = () => {
  let ref = window.location.hostname;

  if (ref.indexOf('.') !== -1) {
    ref = ref.split('.')[0];
  }

  return ref;
};

/**
 * Retorna a máscara adequada baseada no valor do telefone
 * @param value Valor do telefone
 * @returns Máscara apropriada
 */
export function getPhoneMaskValue(value: string): string {
  // Máscaras flexíveis para telefones
  const phoneMasks = [
    '(00) 0000-0000', // Telefone fixo: (27) 3061-6209
    '(00) 00000-0000', // Celular: (27) 99627-9047
    '0000 000 0000', // 0800: 0800 649 0300
  ];

  if (!value) return phoneMasks[0];

  // Remove todos os caracteres não numéricos para análise
  const cleanValue = value.replace(/\D/g, '');

  // international number: 44 7599 902913
  if (cleanValue.length > 11) {
    return '00 0000 000000';
  }

  // 0800: 0800 649 0300 (11 dígitos iniciando com 0800)
  if (
    cleanValue.startsWith('0800') ||
    (cleanValue.length === 11 && cleanValue.startsWith('0800'))
  ) {
    return '0000 000 0000';
  }

  // Celular: (27) 99627-9047 (11 dígitos no total)
  if (cleanValue.length === 11) {
    return '(00) 00000-00009';
  }

  // Telefone fixo: (27) 3061-6209 (10 dígitos no total)
  return '(00) 0000-00009';
}

/**
 * Evento chamado quando o valor do telefone muda para ajustar a máscara dinamicamente
 * @param event Evento de input
 * @param fieldName Nome do campo no formulário
 */
export function onPhoneInput(event: any, fieldName: string) {
  const value = event.target.value;
  const mask = getPhoneMaskValue(value);

  // Força a atualização da máscara no próximo ciclo
  setTimeout(() => {
    const input = event.target;
    input.setAttribute('mask', mask);
  });
}

export function handleTypeDays(
  value: number,
  dataStartAt: any,
  daysType: string,
): moment.Moment {
  // dataStartAt pode ser string (13/11/2025) ou Date
  if (typeof dataStartAt === 'string' && dataStartAt.indexOf('/') !== -1) {
    const parts = dataStartAt.split('/');
    dataStartAt = new Date(
      Number(parts[2]),
      Number(parts[1]) - 1, // mes começa em 0
      Number(parts[0]),
    );
  }

  let result = moment(dataStartAt).startOf('day'); // zera hora

  if (daysType === EventModel.DAYS_TYPES.BUSINESS.CODE) {
    let addedDays = 0;

    while (addedDays < value) {
      result = result.add(1, 'day');
      const dayOfWeek = result.isoWeekday(); // 1=segunda ... 7=domingo
      if (dayOfWeek <= 5) {
        // segunda a sexta
        addedDays++;
      }
    }
  } else {
    result = result.add(value, 'day');
  }

  return result;
}

export function handleCompanyTexts(company: any, entity: any) {
  if (entity.type === EventModel.TYPES.THIRD_PARTY_MONITORING.CODE) {
    company.openingInitialText = company.openingInitialTextThirdParty
      ? company.openingInitialTextThirdParty
      : company.openingInitialText;

    company.consentTermText = company.consentTermTextThirdParty
      ? company.consentTermTextThirdParty
      : company.consentTermText;

    company.cancelText = company.cancelTextThirdParty
      ? company.cancelTextThirdParty
      : company.cancelText;

    company.deliveryText = company.deliveryTextThirdParty
      ? company.deliveryTextThirdParty
      : company.deliveryText;

    company.paymentText = company.paymentTextThirdParty
      ? company.paymentTextThirdParty
      : company.paymentText;

    company.eventInfoText = company.eventInfoTextThirdParty
      ? company.eventInfoTextThirdParty
      : company.eventInfoText;

    company.partialAgreementText = company.partialAgreementTextThirdParty
      ? company.partialAgreementTextThirdParty
      : company.partialAgreementText;

    company.fullAgreementText = company.fullAgreementTextThirdParty
      ? company.fullAgreementTextThirdParty
      : company.fullAgreementText;
  }

  if (entity.type === EventModel.TYPES.PROPERTY_DAMAGE.CODE) {
    company.openingInitialText = company.openingInitialTextPropertyDamage
      ? company.openingInitialTextPropertyDamage
      : company.openingInitialText;

    company.consentTermText = company.consentTermTextPropertyDamage
      ? company.consentTermTextPropertyDamage
      : company.consentTermText;

    company.cancelText = company.cancelTextPropertyDamage
      ? company.cancelTextPropertyDamage
      : company.cancelText;

    company.paymentText = company.paymentTextPropertyDamage
      ? company.paymentTextPropertyDamage
      : company.paymentText;
  }

  return company;
}
